import { motion } from 'framer-motion'
import {
  StyleBanner,
  StyleBannerWrapper,
  StyleDownloadButtonsWrapper,
  StyleGradientText,
} from './style'
import { AppleStoreSvg, GooglePlayStoreSvg } from '@pages/front/svgs/svg'
import { StyleText, StyleTextWrapper } from '@pages/front/commons/Text/style'
import { StyleImageWrapper } from '@pages/front/commons/ImageWrapper/style'

const MotionTextWrapper = motion(StyleTextWrapper)
const MotionGradientText = motion(StyleGradientText)
const MotionText = motion(StyleText)
const MotionDownloadButtonsWrapper = motion(StyleDownloadButtonsWrapper)
const MotionImageWrapper = motion(StyleImageWrapper)

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.3,
    },
  },
}

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.5,
      ease: 'easeOut',
    },
  },
}

const imageVariants = {
  hidden: { scale: 0.8, opacity: 0 },
  visible: {
    scale: 1,
    opacity: 1,
    transition: {
      duration: 0.6,
      ease: 'backOut',
    },
  },
}

const Banner = ({ data }) => {
  return (
    <StyleBannerWrapper>
      <StyleBanner bgColor={data.bgColor}>
        <MotionTextWrapper
          rowGap="20"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <MotionGradientText variants={itemVariants}>
            {data.title}
          </MotionGradientText>

          <MotionText
            variants={itemVariants}
            color="#414146"
            fontSize="24"
            centered
          >
            {data.subTitle}
          </MotionText>

          <MotionDownloadButtonsWrapper variants={itemVariants}>
            <motion.div
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              dangerouslySetInnerHTML={{ __html: GooglePlayStoreSvg }}
            />
            <motion.div
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              dangerouslySetInnerHTML={{ __html: AppleStoreSvg }}
            />
          </MotionDownloadButtonsWrapper>
        </MotionTextWrapper>

        <MotionImageWrapper
          variants={imageVariants}
          initial="hidden"
          animate="visible"
          widthsm="80%"
        >
          <img src={data.imgSrc} alt="" />
        </MotionImageWrapper>
      </StyleBanner>
    </StyleBannerWrapper>
  )
}

export default Banner
